import {Component, Input, Output, EventEmitter, Inject, PLATFORM_ID} from '@angular/core';
import {BehaviorSubject, of} from 'rxjs';
import {DeviceCardComponent} from "../device-card/device-card.component";
import {NgForOf, NgIf, AsyncPipe, isPlatformBrowser} from "@angular/common";
import {NoCompatibleDevicesComponent} from "../../components/no-compatible-devices/no-compatible-devices.component";
import {LoadingComponent} from "../loading/loading.component";
import {catchError, map, tap} from "rxjs/operators";
import {ApiHandlerService} from "../../core/services/apiCall.service";
import {AuthService} from "../../core/services/auth.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-device-list',
    templateUrl: './device-list.component.html',
    standalone: true,
    imports: [
        DeviceCardComponent,
        NgForOf,
        NgIf,
        NoCompatibleDevicesComponent,
        AsyncPipe,
        LoadingComponent
    ],
    styleUrls: ['./device-list.component.scss']
})
export class DeviceListComponent {
    @Input() devices: any[] = [];
    @Input() selectedDevices: any[] | undefined;
    @Output() deviceSelect = new EventEmitter<any>();

    isLoading$ = new BehaviorSubject<boolean>(true);
    constructor(
        private service: ApiHandlerService,
        private authService: AuthService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
    }
    ngOnChanges(): void {
        // Set isLoading to false when devices are loaded
        this.isLoading$.next(this.devices.length === 0);
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const user = localStorage.getItem("user");
            if (user) {
                this.getAssets(user);
            }
        }
    }

    getAssets(user: string): void {
        this.service.Get(`devices/userassets?user=${user}`).pipe(
            map((data: any) => {
                if (data.code === 401) {
                    this.authService.logout();
                    this.router.navigate(['/login']);
                    return [];
                }
                return data?.data?.devices ?? [];
            }),
            tap((filteredDevices) => {
                this.devices = filteredDevices;
                this.isLoading$.next(false); // Loading is done
            }),
            catchError((error: any) => {
                console.error('Error fetching assets:', error);
                this.isLoading$.next(false); // Stop loading on error
                return of([] as any[]); // Specify the expected type
            })

        ).subscribe();
    }

    isSelected(device: any): boolean {
        return <boolean>this.selectedDevices?.some((d: any) => d.id === device.id);
    }

    onDeviceClick(device: any) {
        this.deviceSelect.emit(device);
    }

}